<!--确认弹出框按钮-->
<template>
  <MyButton @click="click_open" v-bind="$attrs">
    <slot></slot>
  </MyButton>
</template>

<script setup>
import { ElMessageBox } from "element-plus";

const props = defineProps({
  // 弹框标题
  title: {
    type: String,
    default: "提示",
  },
  // 提示内容
  hint: {
    type: String,
    default: "确定要删除吗?",
  },
  type: {
    type: String,
    default: "warning",
  }
});
const emits = defineEmits(["confirm", "cancel"]);

const click_open = () => {
  ElMessageBox.confirm(props.hint, props.title, {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: props.type,
  })
    .then(() => {
      emits("confirm");
    })
    .catch(() => {
      emits("cancel");
    });
};
</script>

<style scoped lang="scss"></style>
